<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ack" epub:type="acknowledgments" role="doc-acknowledgments">
<p class="SP" id="ack"> </p>
<p class="FM-Head--fmh-"><span aria-label="5" id="pg_5" role="doc-pagebreak"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><b>ACKNOWLEDGMENTS</b></span></span></p>
<p class="FM-Text-No-Indent--fmtx1-">The usual suspects: my wife, Mary; Jennifer Gunnels and Becky Maines at the publisher; Steven Spruill, Elizabeth Monteleone, Dannielle Romeo, Ann Voss Peterson, Alfred Caplin, and my agent, Albert Zuckerman. Thanks for your efforts.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?38a839d6